import React, { ReactNode, useCallback, MouseEvent, MutableRefObject } from 'react';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

import { ReactComponent as ChevronRightIcon } from '../../../icons/chevronRight.svg';
import { StyledDropListItem } from './DropList.styles';

export interface DropListItemProps<OptionValue> extends Omit<SCP<'li'>, 'value' | 'as'> {
  label: ReactNode;
  value: OptionValue;
  isEmpty: boolean;
  isFocused: boolean;
  isSearch: boolean;
  targetRef: MutableRefObject<HTMLElement>;
  icon: ReactNode;
  onItemClick: (value: OptionValue, event: MouseEvent, options?: { targetRef: MutableRefObject<HTMLElement> }) => void;
}

const DropListItem = <Value, >({ value, icon, label, isSearch, isFocused, targetRef, onItemClick, ...props }: DropListItemProps<Value>) => {
  const handleClick = useCallback((event: MouseEvent<HTMLLIElement>) => {
    onItemClick(value, event, { targetRef });
  }, [onItemClick, targetRef, value]);

  return (
    <StyledDropListItem
      isFocused={isFocused}
      onMouseDown={handleClick}
      {...props}
    >
      {icon}{label}{isSearch && <ChevronRightIcon />}
    </StyledDropListItem>
  );
};

export default DropListItem;
